<template>
  <div class="m-highlight-data">
    <b-modal
      id="highlight-olap-data-modal"
      v-model="localActive"
      size="custom-size"
      centered
      hide-footer
      hide-header
      @close="localActive = false"
    >
      <svg
        class="m-highlight-data-close"
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="localActive = false"
      >
        <path
          d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
          fill="#8E9CBB"
        />
        <path
          d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
          fill="#8E9CBB"
        />
      </svg>
      <div class="m-highlight-data-title">Подсветка данных OLAP-отчета</div>
      <c-switcher
        v-model="switcherLocal"
        class="m-highlight-data-switcher"
        type="group"
        :items="[
          { label: 'Строки', value: 'lines' },
          { label: 'Столбцы', value: 'columns' },
        ]"
      />
      <div class="m-highlight-data-params">
        <div class="m-highlight-data-params-lines">
          <div class="m-highlight-data-params-lines-title">Параметры строк</div>
          <c-switcher class="m-highlight-data-params-lines-checkbox" type="checkbox" label="Филиал" />
          <c-switcher class="m-highlight-data-params-lines-checkbox" type="checkbox" label="Должность" />
          <c-switcher class="m-highlight-data-params-lines-checkbox" type="checkbox" label="Дата (год)" />
          <c-switcher class="m-highlight-data-params-lines-checkbox" type="checkbox" label="Дата (месяц)" />
        </div>
        <div class="m-highlight-data-params-columns">
          <div class="m-highlight-data-params-columns-title">Параметры столбцов</div>
          <c-switcher class="m-highlight-data-params-columns-checkbox" type="checkbox" label="Выручка повар южная" />
          <c-switcher class="m-highlight-data-params-columns-checkbox" type="checkbox" label="Выручка суши" />
          <c-switcher class="m-highlight-data-params-columns-checkbox" type="checkbox" label="Выручка филиала" />
          <c-switcher class="m-highlight-data-params-columns-checkbox" type="checkbox" label="Сумма к выплате" />
        </div>
      </div>
      <div class="m-highlight-data-fill">
        <div class="m-highlight-data-fill-title">Цветовая шкала</div>
        <div class="m-highlight-data-fill-switchers">
          <div class="m-highlight-data-fill-switchers-col">
            <c-switcher
              class="m-highlight-data-fill-switchers-col-item"
              name="radio-group-button"
              value="1"
              type="radio-colours"
              :colours="['#A969AF', '#BE83B9', '#D49EC2', '#E7B5CA', '#FFD4D4']"
              label="Один"
            />
            <c-switcher
              class="m-highlight-data-fill-switchers-col-item"
              name="radio-group-button"
              value="2"
              :colours="['#29C4AA', '#4BD5BC', '#8EE2B5', '#C7EEA9', '#EFF5A8']"
              type="radio-colours"
              label="Два"
            />
            <c-switcher
              class="m-highlight-data-fill-switchers-col-item"
              name="radio-group-button"
              value="3"
              :colours="['#9E77EC', '#B18CFB', '#B8A2EB', '#CAB6F8', '#DFD8FF']"
              type="radio-colours"
              label="Три"
            />
          </div>
          <div class="m-highlight-data-fill-switchers-col">
            <c-switcher
              class="m-highlight-data-fill-switchers-col-item"
              name="radio-group-button"
              value="4"
              :colours="['#A65216', '#BB7940', '#D3A56F', '#EACE9B', '#FEF4C3']"
              type="radio-colours"
              label="Четыре"
            />
            <c-switcher
              class="m-highlight-data-fill-switchers-col-item"
              name="radio-group-button"
              value="5"
              :colours="['#657CFF', '#6DA0F8', '#73C2EF', '#78DCEA', '#7DF9E1']"
              type="radio-colours"
              label="Пять"
            />
            <c-switcher
              class="m-highlight-data-fill-switchers-col-item"
              name="radio-group-button"
              value="6"
              :colours="['#DC427F', '#E6678C', '#EF8B97', '#F6A8A1', '#FDC8AA']"
              type="radio-colours"
              label="Шесть"
            />
          </div>
        </div>
      </div>
      <div class="m-highlight-data-buttons">
        <c-button class="m-highlight-data-buttons-cancel" label="Сбросить" @click="localActive = false" />
        <c-button class="m-highlight-data-buttons-apply" label="Применить" color="primary" />
      </div>
    </b-modal>
  </div>
</template>

<script>
import Button from "@/components/controls2/Button";
import Switcher from "@/components/controls2/Switcher";

export default {
  name: "highlight-data-modal",
  components: {
    "c-button": Button,
    "c-switcher": Switcher,
  },
  props: ["active", "countBonusesCurrent"],
  data() {
    return {
      localActive: false,
      switcherLocal: "lines",
    };
  },

  watch: {
    localActive(value) {
      if (!value) {
        this.$emit("close");
      }
    },
    active(value) {
      this.localActive = value;
    },
  },

  methods: {
    closeModal() {
      this.localActive = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.m-highlight-data {
  position: relative;

  &-close {
    cursor: pointer;
    position: absolute;
    top: 12px;
    right: 10px;
  }

  &-title {
    font-family: Fira Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 100%;
  }

  &-switcher {
    margin-top: 27px;
  }

  &-params {
    display: flex;
    margin-top: 24px;

    &-lines {
      display: flex;
      flex-direction: column;

      &-title {
        font-weight: 500;
        font-size: 15px;
        line-height: 108%;
        margin-bottom: 10px;
      }

      &-checkbox {
        margin-top: 10px;
      }
    }

    &-columns {
      margin-left: 153px;
      display: flex;
      flex-direction: column;

      &-title {
        font-weight: 500;
        font-size: 15px;
        line-height: 108%;
        margin-bottom: 10px;
      }

      &-checkbox {
        margin-top: 10px;
      }
    }
  }

  &-fill {
    margin-top: 14px;

    &-title {
      font-weight: 500;
      font-size: 15px;
      line-height: 108%;
      margin-bottom: 8px;
    }

    &-switchers {
      display: flex;

      &-col {
        display: flex;
        flex-direction: column;

        &:nth-child(2) {
          margin-left: 22px;
        }

        &-item {
          margin-top: 10px;
        }
      }
    }
  }

  &-buttons {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;

    &-cancel {
      max-width: 115px;
    }

    &-apply {
      max-width: 130px;
      margin-left: 12px;
    }
  }
}
</style>
